/// <reference path="ProgressIndicator.js" />
/// <reference path="DOMAttached.js" />
/// <reference path="GenericSounds.js" />
/// <reference path="LegacyHelper.js" />

class ListBase extends DOMAttached {
	constructor(el, options) {
		super(el, Object.assign({
			currentPage: 0,
			lastPage: false,
			pagingEffect: 'none',
			fixDimensions: true,
			reversePagingEffect: false,
			noProgressIndicator: false,
			legacy: true,
			removeButtonsForOnePageLists: false,
			maxHeight: 0
		}, options));

		this.progressIndicator = new ProgressIndicator(this.el);
		this.el.attachedObj = this;
		this.listEl = this.el.querySelector('.fxListWrapper');

		if (GenericSoundsInstance == null) {
			new GenericSounds(this.options.FeedbackSoundOn);
		}

		if (this.listEl == undefined) {
			this.listEl = this.el.querySelector('ul');
		}

		this.prevBtn = this.el.querySelectorAll('.prevBtn');
		this.nextBtn = this.el.querySelectorAll('.nextBtn');

		if (options.buttonsMustBeChildren == true) {
			var children = Array.from(this.el.children);

			for (var i = 0; i < children.length; i++) {
				if (children[i].classList.contains('prevBtn'))
					this.prevBtn = new Array(children[i]);

				if (children[i].classList.contains('nextBtn'))
					this.nextBtn = new Array(children[i]);
			}
		}

		this.setBtnVisibility();

		this.prevBtn.forEach(function(e) {
			this.safeObserve(e, 'click', this.onPrevBtn.bind(this));
			this.safeObserve(e, 'doubleclick', this.onPrevBtn.bind(this));
		}.bind(this));

		this.nextBtn.forEach(function(e) {
			this.safeObserve(e, 'click', this.onNextBtn.bind(this));
			this.safeObserve(e, 'doubleclick', this.onNextBtn.bind(this));
		}.bind(this));

		this.disablePaging = false;
		this.dimensionsFixed = false;

		if (this.options.progressDotsControl != null && typeof(this.options.progressDotsControl) != 'undefined') {
			this.setupDotNavigation();
		}

		this.registerUnloadAction(this.cleanUp.bind(this));
	}

	setupDotNavigation() {
		var children = Array.from(document.getElementById(this.options.progressDotsControl).children);

		for (var i = 0; i < children.length; ++i) {
			this.safeObserve(children[i], 'click', this.onDotClick.bind(this));
			if (i == this.options.currentPage) {
				children[i].setAttribute('src', this.options.progressDotsFullDotImageUrl);
			}
		}
	}

	resetDots() {
		var children = Array.from(document.getElementById(this.options.progressDotsControl).children);

		for (var i = 0; i < children.length; ++i) {
			if (children[i].getAttribute('src') != this.options.progressDotsEmptyDotImageUrl) {
				children[i].setAttribute('src', this.options.progressDotsEmptyDotImageUrl);
			}
		}
	}

	onDotClick(ev) {
		// set all dots to default image (empty)
		this.resetDots();

		// set full dot image for clicked element
		ev.currentTarget.setAttribute('src', this.options.progressDotsFullDotImageUrl);

		// which page to load?
		var classNames = $w(ev.currentTarget.className);
		for (var i = 0; i < classNames.length; ++i) {
			if (classNames[i].startsWith('dot_')) {
				var page = classNames[i].substring(4);
				this.loadPage(page);
				return;
			}
		}

	}

	cleanUp() {
		this.listEl = null;
		this.prevBtn = null;
		this.nextBtn = null;
		this.newList = null;
	}

	setBtnVisibility() {
		this.prevBtn.forEach(function(e) {
			// Originally, this only used the deactivated css class
			// to indicate controls which should not be used.
			// However, to be bootstrap compatible, we want to use the
			// disabled class instead. However, because some legacy JS and
			// CSS relies on the deactivated class, for now we just add
			// and remove both classes.
			if (this.options.currentPage == 0 && !this.options.circle) {
				e.classList.add("deactivated");
				e.classList.add("disabled");
			} else {
				e.classList.remove("deactivated");
				e.classList.remove("disabled");
			}

			this.enableButton(e, this.options.currentPage != 0 || this.options.circle);
		}.bind(this));
		this.nextBtn.forEach(function(e) {
			if (this.options.lastPage && !this.options.circle) {
				e.classList.add("deactivated");
				e.classList.add("disabled");
			} else {
				e.classList.remove("deactivated");
				e.classList.remove("disabled");
			}

			this.enableButton(e, !this.options.lastPage || this.options.circle);
		}.bind(this));

		if (this.options.removeButtonsForOnePageLists) {
			if (this.options.lastPage && this.options.currentPage == 0) {
				this.prevBtn.forEach(function(e) {
					e.style.visibility = 'hidden';
					e.classList.add("mia-u-remove");
				});

				this.nextBtn.forEach(function(e) {
					e.style.visibility = 'hidden';
					e.classList.remove("mia-u-remove");
				});

				this.el.style.paddingTop = "0px";
				this.el.style.paddingBottom = "0px";

				var buttonWrappers = this.el.querySelectorAll(".mia-ListHeaderFooter");
				buttonWrappers.forEach(function(w) {
					if (!w.classList.contains("legacyControl")) {
						w.remove();
					}
				});
			}
		}
	}

	enableButton(btn, enabled) {
		if (this.options.buttonDeactivation == "TurnGrey") {
			if (!enabled) {
				btn.style.backgroundImage = btn.style.backgroundImage.replace("_grey.png", ".png").replace(".png", "_grey.png");
				btn.style.cursor = "default";
			} else {
				btn.style.backgroundImage = btn.style.backgroundImage.replace("_grey.png", ".png");
				btn.style.cursor = "pointer";
			}
		} else if (this.options.buttonDeactivation == "Remove") {
			if (enabled)
				btn.style.display = '';
			else
				btn.style.display = 'none';
		}
	}

	onPrevBtn(ev) {
		if (this.disablePaging) return;
		if (!this.dimensionsFixed && this.options.fixDimensions)
			this.fixDimensions();
		if (this.options.currentPage > 0) {
			this.disablePaging = true;
			this.loadPage(this.options.currentPage - 1);
			if (this.options.pagingEffect == 'none') GenericSoundsInstance.clickSound();
		} else if (this.options.circle) {
			this.disablePaging = true;
			this.loadPage(this.options.count - 1);
		}
	}

	onNextBtn(ev) {
		if (this.disablePaging) return;
		if (!this.dimensionsFixed && this.options.fixDimensions)
			this.fixDimensions();
		if (!this.options.lastPage) {
			this.disablePaging = true;
			this.loadPage(this.options.currentPage + 1);
			if (this.options.pagingEffect == 'none') GenericSoundsInstance.clickSound();
		} else if (this.options.circle) {
			this.disablePaging = true;
			this.loadPage(0);
		}
	}

	fixDimensions() {
		if (this.options.legacy)
			return;

		this.dimensionsFixed = true;

		if (legacyGlobal.isIE) {
			var elDims = { width: this.el.offsetWidth, height: this.el.offsetHeight };

			this.el.style.height = elDims.height + 'px';
			this.el.style.width = elDims.width + 'px';

			var newDims = { width: this.el.offsetWidth, height: this.el.offsetHeight };
			var diffX = newDims.width - elDims.width;
			var diffY = newDims.height - elDims.height;
			if (diffX != 0 || diffY != 0) {
				this.el.style.height = (elDims.height - diffY) + 'px';
				this.el.style.width = (elDims.width - diffX) + 'px';
			}
		} else {
			this.el.style.height = this.window.getComputedStyle(el).getPropertyValue("height");
			this.el.style.width = this.window.getComputedStyle(el).getPropertyValue("width");
		}
	}

	resetDimensions() {
		this.el.style.height = "";
		this.el.style.width = "";
		this.listEl.style.height = "";
		this.listEl.style.width = "";
		this.dimensionsFixed = false;
	}

	displayPage(page, oldPageNum) {
		this.newList = document.createElement('div');
		this.newList.innerHTML = page;
		this.newList = this.newList.firstElementChild;
		evalScripts(this.newList);
	
		if (!this.options.legacy && this.dimensionsFixed && this.listEl) {
			const elDim = {
				width: this.listEl.offsetWidth,
				height: this.listEl.offsetHeight
			};
			this.newList.style.width = `${elDim.width}px`;
			this.newList.style.height = `${elDim.height}px`;
		}
	
		if (this.options.progressDotsControl) {
			const dotContainer = document.getElementById(this.options.progressDotsControl);
			const dots = Array.from(dotContainer.children);
			if (oldPageNum != null && dots[oldPageNum]) {
				dots[oldPageNum].setAttribute('src', this.options.progressDotsEmptyDotImageUrl);
			}
			if (dots[this.options.currentPage]) {
				dots[this.options.currentPage].setAttribute('src', this.options.progressDotsFullDotImageUrl);
			}
		}
	
		const pagingEffect = this.options.pagingEffect;
		const samePage = this.options.currentPage === oldPageNum;
		const isEffectEnabled = ['horizSlide', 'vertSlide', 'fade'].includes(pagingEffect) || samePage;
	
		if (!legacyGlobal.isIE6 && isEffectEnabled) {
			this.listEl.style.position = 'absolute';
			this.listEl.parentNode.insertBefore(this.newList, this.listEl.nextSibling);
			this.newList.style.visibility = 'hidden';
	
			if (pagingEffect === 'vertSlide') {
				this.stretchPagesToUniformHeight();
			}
	
			if (!samePage && ['horizSlide', 'vertSlide'].includes(pagingEffect)) {
				let edge1 = 'left', edge2 = 'right';
				if (pagingEffect === 'vertSlide') {
					edge1 = oldPageNum < this.options.currentPage ? 'top' : 'bottom';
					edge2 = oldPageNum < this.options.currentPage ? 'bottom' : 'top';
				} else if (pagingEffect === 'horizSlide') {
					edge1 = oldPageNum < this.options.currentPage ? 'left' : 'right';
					edge2 = oldPageNum < this.options.currentPage ? 'right' : 'left';
				}
	
				if (this.options.reversePagingEffect
					|| (this.options.circle
						&& ((this.options.currentPage === 0 && oldPageNum !== 1)
						|| (this.options.currentPage === this.options.count - 1 && oldPageNum === 0)))) {
					[edge1, edge2] = [edge2, edge1];
				}
	
				GenericSoundsInstance.longWhooshSound();
	
				const effDuration = 1.0;
	
				const fromOff = this.getSlideOffset(edge1, this.listEl);
				const toOn = this.getSlideOffset(edge2, this.newList);
	
				gsap.set(this.newList, { ...toOn, visibility: 'visible' });
	
				const timeline = gsap.timeline({
					onComplete: () => {
						this.cleanupAfterPageSwitch();
					}
				});
	
				timeline
					.to(this.listEl, { ...fromOff, duration: effDuration, ease: 'power1.inOut' }, 0)
					.to(this.newList, { x: 0, y: 0, duration: effDuration, ease: 'power1.inOut' }, 0);
	
			} else {
				gsap.set(this.newList, { opacity: 0, visibility: 'visible' });
	
				gsap.to(this.listEl, { opacity: 0, duration: 0.05 });
				gsap.to(this.newList, {
					opacity: 1,
					duration: 0.05,
					onComplete: () => {
						this.cleanupAfterPageSwitch();
					}
				});
			}
	
		} else {
			this.listEl.parentNode.insertBefore(this.newList, this.listEl.nextSibling);
			this.cleanupAfterPageSwitch();
		}
	
		this.onLoadPage(this.listEl);
	
		if (this.options.pagingEffect === 'returnToTop' && this.el) {
			const position = this.el.offsetTop - 32;
			window.scrollTo(0, position);
		}
	}
	
	getSlideOffset(edge, el) {
		const rect = el.getBoundingClientRect();
		switch (edge) {
			case 'left': return { x: -rect.width };
			case 'right': return { x: rect.width };
			case 'top': return { y: -rect.height };
			case 'bottom': return { y: rect.height };
			default: return {};
		}
	}
	
	cleanupAfterPageSwitch() {
		this.removeElement(this.listEl);
		this.listEl = this.newList;
		this.newList = undefined;
		this.reenablePaging();
	
		if (this.options.legacy) {
			this.listEl.style.height = '';
			this.listEl.style.width = '';
		}
	
		if (legacyGlobal.isIE7) {
			this.listEl.style.display = 'none';
			setTimeout(this.renderPageIE7.bind(this), 1);
		}
	}

	stretchPagesToUniformHeight() {
		if (this.listEl.offsetHeight >= this.options.maxHeight) {
			this.options.maxHeight = this.listEl.offsetHeight;
			this.newList.style.height = this.options.maxHeight + "px";
		} else {
			this.listEl.style.height = this.options.maxHeight + "px";
		}
	}

	standardJSONRequest(url) {
		if ((this.blockRequests != undefined) || this.requestRunning)
			return;
		this.requestRunning = true;
		axios(url, {
			method: 'get',
			params: {
				nocache: Math.random()
			}
		}).then(this.standardJSONSuccess.bind(this));
	}

	standardJSONSuccess(req) {
		this.requestRunning = false;
		var json = req.data;

		if (json.html == undefined || json.html.length == 0)
			return;

		var oldPage = this.options.currentPage;
		var html = json.html;
		json.html = undefined;
		this.options = Object.assign(this.options, json);
		this.setBtnVisibility();
		this.displayPage(html, oldPage);
	}

	reenablePaging(req) {
		this.disablePaging = false;
	}

	refresh() {
		this.disablePaging = true;
		this.loadPage(this.options.currentPage);
	}

	// Overriding function should call displayPage(...) to display the page once it's loaded.
	// Overriding function should set lastPage.
	// Overriding function should set currentPage.
	// Instead of all of the above, the overriding function can let standardJSONRequest take care of everything.
	loadPage(page) {
		if (!this.options.noProgressIndicator) {
			if (this.options.customProgressIndicator)
				this.progressIndicator.showProgressIndicator("div", false);
			else
				this.progressIndicator.showProgressIndicator("div.listCtrl", false);
		}
	}

	onLoadPage(pageEl) {
		if (!this.options.noProgressIndicator) this.progressIndicator.hideProgressIndicator();
		this.el.dispatchEvent(new CustomEvent('list:criteriaChanged', { detail: { options: this.options } }));
		setTimeout(this.fixDimensions.bind(this), 10);
	}

	renderPageIE7() {
		this.listEl.style.display = "block";
	}
}
